/**
 * Dashboard Page
 * Uses shadcn/ui Card components for consistent styling
 */


export function DashboardPage() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold">Dashboard</h1>
                <p className="text-muted-foreground">Welcome to MTOMICS MDM</p>
            </div>




        </div>
    );
}
